import { IS_AUTHORIZED_PATH } from '@/api/paths';
import { headRequest } from '@/utils/swr-utils';
import { GetAccessTokenFunc, IsAuthorizedFunc } from '@digital-services/shell';
import axios from 'axios';
import { useCallback } from 'react';

export function useIsAuthorized(): IsAuthorizedFunc {
  const isAuthorizedFunction = useCallback(
    async (getAccessToken: GetAccessTokenFunc): Promise<boolean> => {
      try {
        await headRequest(IS_AUTHORIZED_PATH, getAccessToken);
        return true;
      } catch (err) {
        if (axios.isAxiosError(err) && err.response?.status === 404) {
          return false;
        }
        throw err;
      }
    },
    []
  );

  return isAuthorizedFunction;
}
